import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import sortbydot from '../../assets/image/sort_by_group.svg';
import Button from '../../component/ui/Button';
import Table from '../../component/table/Table';
import Pagination from '../../component/pagination';
import { toast } from 'react-toastify';
import { ExportTable } from '../../store/action/export/Export';
import {
	exportPurchaseOrderData,
	fetchPurchaseOrders,
	generatePurchaseOrderPdf,
	getPurchaseOrders,
	update_bulk_purchase_order_status,
} from '../../services/purchaseOrder';
import { getDate } from '../../utils/dateUtils';
import advanceFilterIcon from '../../assets/image/advanceFilter.svg';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import FullCircle from '../../assets/image/full_circle.png';
import HalfCircle from '../../assets/image/half_circle.png';
import EmptyCircle from '../../assets/image/empty_circle.png';
import AdvanceFilter from '../../component/Filter/AdvanceFilter';
import advanceFilterOptions from '../../component/Filter/advanceFilterOptions';
import clearAllFilter from '../../assets/image/clearAllFilter.svg';
import addFilter from '../../assets/image/AddFilter.svg';
import AdvanceFilterSelectInput from '../../component/Filter/AdvanceFilterSelectInput';
import DeletePurchaseOrderModel from './components/DeletePurchaseOrderModel';
import { useDispatch, useSelector } from 'react-redux';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../store/action/advanceFilter';
import { getFiltersParams } from '../../helper';
import PageLoader from '../../component/PageLoader';
import { hasPermission } from '../../utils/controller';

const sortIconMap = {
	asc: <IoIosArrowRoundUp />,
	desc: <IoIosArrowRoundDown />,
};

const PurchaseOrder = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		orderBy: advanceFilterOrderby,
		sortBy: advanceFilterSortBy,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);
	const suburl = localStorage.getItem('suburl');
	const [totalPages, setTotalPages] = useState(0);
	const [loader, setLoader] = useState(false);
	const [bulkAction, setBulkAction] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [headerDropDown, setHeaderDropDown] = useState('Active Purchase Orders');
	const [sortDirection, setSortDirection] = useState({ purchase_order_id: 'asc' });
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const [isDeleteBulkConfirmationModalOpen, setIsDeleteBulkConfirmationModalOpen] = useState(false);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [selectedPRListForDelete, setSelectedPRListForDelete] = useState([]);
	const [isBulkActionButtonDisabled, setIsBulkActionButtonDisabled] = useState(false);
	const [showCancelOrderButton, setShowCancelOrderButton] = useState(false);
	const [showIssuedButton, setShowIssuedButton] = useState(false);
	const [purchaseOrderParams, setPurchaseOrderParams] = useState({
		page: 1,
		pageSize: 20,
		orderBy: 'created_at',
		sortBy: 'desc',
		filters: {},
	});

	const [deselectRows, setDeselectRows] = useState(null);
	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};

	const navigateRouter = (path) => {
		navigate(path);
	};

	const onRowClick = (id) => {
		if (id && hasPermission('purchases.purchase_orders.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/purchases-order-details/${id}`);
		}
	};

	const FilterDatalist = (param, value, dropDownData) => {
		if (dropDownData === 'Active Purchase Orders') {
			dispatch(clearAdvanceFilter());
			setHeaderDropDown('Active Purchase Orders');
			return;
		}

		setHeaderDropDown(dropDownData);
		dispatch(setSelectedInput({ key: 'status', label: 'Status' }));
		dispatch(setSelectedInputValue({ key: 'status', value: dropDownData }));
		dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
		const selectInputData = [
			{ key: 'is_issued', value: 'Issued' },
			{ key: 'is_pending_approval', value: 'Pending Approval' },
			{ key: 'is_closed', value: 'Closed' },
			{ key: 'is_received', value: 'Received' },
			{ key: 'partially_received', value: 'Partially Received' },
			{ key: 'is_in_transit', value: 'In Transit' },
			{ key: 'is_cancelled', value: 'Cancelled' },
			{ key: 'is_billed', value: 'Billed' },
			{ key: 'is_partially_billed', value: 'Partially Billed' },
		];

		dispatch(setSelectedInputData({ key: 'status', data: selectInputData }));
		const updatedSelectedInput = selectedInputs.map((input) => {
			if (input.key === 'status') {
				return {
					...input,
					value: dropDownData,
				};
			}
			return input;
		});
		const params = getFiltersParams(updatedSelectedInput);
		handleApplyFilters(params);
	};

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.orderBy] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.orderBy]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ orderBy: param.orderBy, sortBy: newDirection }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setPurchaseOrderParams((prev) => ({
				...prev,
				orderBy: param.orderBy,
				sortBy: newDirection,
			}));
		}
	};

	const exportData = (param) => {
		ExportTable(param);
	};

	const PurchaseOrderColoum = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},
		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 93,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						className="header-clickable w-100"
						onClick={() => sortDataList({ orderBy: 'date', sortBy: 'asc' })}
					>
						<div className="header-inner-55">
							<p className="table-header__label_invoices mb-0">
								DATE
								<span className="sort-icon">{sortIconMap[sortDirection?.date]}</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'PO#',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 70,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						className="header-clickable w-100"
						onClick={() => sortDataList({ orderBy: 'purchase_order_id', sortBy: 'asc' })}
					>
						<div className="header-inner-55">
							<p className="table-header__label_invoices mb-0">
								PO#
								<span className="sort-icon">{sortIconMap[sortDirection?.purchase_order_id]}</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				const PO = JSON.parse(params.data['PO#']);
				return (
					<p>
						{PO?.po_number}
						{PO?.is_draft === 1 && (
							<span
								style={{
									backgroundColor: '#718096',
									color: 'white',
									borderRadius: '20px',
									padding: '2px 10px',
									paddingBottom: '3px',
									marginLeft: '10px',
									fontSize: '11px',
								}}
							>
								Draft
							</span>
						)}
					</p>
				);
			},
		},
		{
			field: 'VENDOR NAME',
			suppressSizeToFit: true,
			headerClass: 'HeaderBg',
			flex: 1,
			minWidth: 95,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						className="header-clickable w-100"
						onClick={() => sortDataList({ orderBy: 'vendor_name', sortBy: 'asc' })}
					>
						<div className="header-inner-55">
							<p className="table-header__label_invoices mb-0">
								<p className="d-none d-lg-block mb-0">VENDOR NAME</p>
								<p className="d-block d-lg-none mb-0">VEN. NAME</p>
								<span className="sort-icon">{sortIconMap[sortDirection?.vendor_name]}</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'Status',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 230,
			flex: 1,
			cellClass: 'left-align',
			cellRenderer: (params) => {
				const status = params.data?.Status || '';
				let statusCode = '';

				switch (status) {
					case 'Received':
						statusCode = '#6AA247';
						break;
					case 'Pending':
						statusCode = '#FFC008';
						break;
					case 'Pending Approval':
						statusCode = '#3B58FF';
						break;
					case 'Approved':
						statusCode = '#3B58FF';
						break;
					case 'Issued':
						statusCode = '#3B58FF';
						break;
					case 'Closed':
						statusCode = '#989C95';
						break;
					case 'Deleted':
						statusCode = '#D30000';
						break;
					case 'Partially Received':
						statusCode = '#FFA500';
						break;
					case 'In-Transit':
						statusCode = '#11caf0';
						break;
					default:
						statusCode = '#DC3545';
						break;
				}

				return (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							height: '24px',
							fontSize: '10px',
							borderRadius: '5px',
							fontWeight: status === 'Draft' ? '' : 'bold',
							margin: '8px 0px',
							color: status === 'Draft' ? 'black' : '#ffffff',
							backgroundColor: status === 'Draft' ? '' : statusCode,
						}}
					>
						{/* Truncated only on md */}
						<span
							className="d-none d-md-inline d-lg-none text-truncate text-center"
						>
							{status === 'Draft' ? 'N/A' : status}
						</span>

						{/* Full text on lg+ and small screens */}
						<span className="d-inline d-md-none d-lg-inline text-center w-100">
							{status === 'Draft' ? 'N/A' : status}
						</span>
					</div>
				);
			},
		},
		{
			field: 'Received',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 90,
			flex: 1,
			cellClass: 'left-align',
			cellRenderer: (params) => {
				const received = JSON.parse(params.data?.Received) || '';
				const { is_received, is_partially_received, status } = received;

				if (
					is_received === 1 &&
					status !== 'Pending Approval' &&
					status !== 'In-Transit' &&
					status !== 'Cancelled' &&
					status !== 'Issued'
				) {
					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								height: '100%',
							}}
						>
							<img
								alt="is_receive?"
								src={FullCircle}
							/>
						</div>
					);
				}

				if (
					is_partially_received === 1 &&
					status !== 'Pending Approval' &&
					status !== 'In-Transit' &&
					status !== 'Cancelled' &&
					status !== 'Issued'
				) {
					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								height: '100%',
							}}
						>
							<img
								alt="is_receive?"
								src={HalfCircle}
							/>
						</div>
					);
				}
				return (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							height: '100%',
						}}
					>
						<img
							alt="is_receive?"
							src={EmptyCircle}
						/>
					</div>
				);
			},
		},
		{
			field: 'Billed',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 65,
			flex: 1,
			cellClass: 'left-align',
			cellRenderer: (params) => {
				const billed = JSON.parse(params.data?.Billed) || '';
				const { is_billed, is_partially_billed } = billed;

				if (is_billed === 1) {
					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								height: '100%',
							}}
						>
							<img
								alt="is_receive?"
								src={FullCircle}
							/>
						</div>
					);
				}

				if (is_partially_billed === 1) {
					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								height: '100%',
							}}
						>
							<img
								alt="is_receive?"
								src={HalfCircle}
							/>
						</div>
					);
				}

				return (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							height: '100%',
						}}
					>
						<img
							alt="is_receive?"
							src={EmptyCircle}
						/>
					</div>
				);
			},
		},
		{
			field: 'Expected By',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 100,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ orderBy: 'expected_delivery_date', sortBy: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								Expected By
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.expected_delivery_date]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
	];

	async function handleUpdateBulkPurchaseOrder(status) {
		try {
			if (bulkAction.length === 0) {
				toast.error('Please select purchase orders!');
				return;
			}
			const body = {
				status,
				purchase_order_ids: bulkAction,
			};
			await update_bulk_purchase_order_status(body);
			toast.success('Status updated successfully!');
			setBulkAction(false);
			setBulkAction([]);
			deselectRows && deselectRows();
			if (isDeleteBulkConfirmationModalOpen) {
				setIsDeleteBulkConfirmationModalOpen(false);
			}
			handleFetchPurcahseOrders();
		} catch (error) {
			toast.error(error.message || 'Something went wrong while updating the Status!');
		}
	}

	function handleOpenBulkDeletePurchaseOrderModal() {
		const selectedPOList = tableData?.reduce((acc, item) => {
			if (bulkAction.includes(item.id)) {
				const poData = JSON.parse(item['PO#']);
				acc.push(poData['po_number']);
				return acc;
			}
			return acc;
		}, []);
		setSelectedPRListForDelete(selectedPOList);
		setIsDeleteBulkConfirmationModalOpen(true);
	}

	async function handleDownloadTableData() {
		try {
			if (bulkAction.length === 0) {
				toast.error('Please select purchase orders!');
				return;
			}
			const params = {
				purchase_order_ids: bulkAction.join(','),
			};
			await exportPurchaseOrderData(params);
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	async function handlePrintAndDownloadPdf(type = 'print') {
		try {
			setLoader(true);
			const pdf_details = await generatePurchaseOrderPdf(bulkAction.join(','), true);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
			}

			if (type === 'download') {
				const fileName = `merged_purchase_orders_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoader(false);
		}
	}

	const handlePageChange = (page) => {
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilterPage({ page: page }));
		} else {
			setPurchaseOrderParams((prev) => ({
				...prev,
				page,
			}));
		}
	};

	function mappedTableData(data) {
		return data?.map((purchase) => {
			return {
				id: purchase.purchase_order_id,
				DATE: getDate(purchase?.date),
				'PO#': JSON.stringify({
					po_number: purchase?.purchase_order_number,
					is_draft: purchase?.is_draft,
				}),
				'VENDOR NAME': purchase?.vendor_name,
				Status: purchase?.status || 'N/A',
				Received: JSON.stringify({
					is_received: purchase.is_received,
					is_partially_received: purchase.is_partially_received,
					status: purchase?.status,
				}),
				Billed: JSON.stringify({
					is_billed: purchase?.is_billed,
					is_partially_billed: purchase?.is_partially_billed,
				}),
				'Expected By':
					purchase?.expected_delivery_date === null
						? 'N/A'
						: getDate(purchase?.expected_delivery_date),
			};
		});
	}

	function handleIsBulkUpdateDisableButton() {
		const purchasesOrder = bulkAction?.reduce((acc, poId) => {
			const isPoFound = tableData?.find((_po) => Number(_po.id) === Number(poId));
			if (isPoFound) acc.push(isPoFound.Status);
			return acc;
		}, []);

		if (purchasesOrder.length === 0) {
			setIsBulkActionButtonDisabled(true);
			return;
		}

		const allReceivedOrIssued = purchasesOrder.every((status) =>
			['Received', 'Partially Received', 'Issued'].includes(status),
		);
		if (allReceivedOrIssued) {
			setShowCancelOrderButton(true);
			setShowIssuedButton(false);
			setIsBulkActionButtonDisabled(false);
			return;
		}

		const allPendingApproval = purchasesOrder.every((status) => status === 'Pending Approval');
		if (allPendingApproval) {
			setShowIssuedButton(true);
			setShowCancelOrderButton(false);
			setIsBulkActionButtonDisabled(false);
			return;
		}

		setShowCancelOrderButton(false);
		setShowIssuedButton(false);
		setIsBulkActionButtonDisabled(true);
	}

	const handleFetchPurcahseOrders = async () => {
		try {
			setLoader(true);
			const { purchaseOrders, totalPages } = await getPurchaseOrders(purchaseOrderParams);
			const mappedPurchaseOrderTableData = purchaseOrders.map((purchase) => {
				return {
					id: purchase.purchase_order_id,
					DATE: getDate(purchase?.date),
					'PO#': JSON.stringify({
						po_number: purchase?.purchase_order_number,
						is_draft: purchase?.is_draft,
					}),
					'VENDOR NAME': purchase?.vendor_name,
					Status: purchase?.status || 'N/A',
					Received: JSON.stringify({
						is_received: purchase.is_received,
						is_partially_received: purchase.is_partially_received,
						status: purchase?.status,
					}),
					Billed: JSON.stringify({
						is_billed: purchase?.is_billed,
						is_partially_billed: purchase?.is_partially_billed,
					}),
					'Expected By':
						purchase?.expected_delivery_date === null
							? 'N/A'
							: getDate(purchase?.expected_delivery_date),
				};
			});
			setTableData(mappedPurchaseOrderTableData);
			setTotalPages(totalPages);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong!');
		} finally {
			setLoader(false);
		}
	};

	//New Filter Start
	async function handleOnFocusSelectedFilterInput(key) {
		let selectInputData = [];
		if (key !== 'status') {
			const { purchaseOrders } = await fetchPurchaseOrders({
				pageSize: 1000,
				filterBy: key,
				filterValue: '',
			});
			selectInputData = purchaseOrders?.map((po) => ({
				key: key === 'vendor_name' ? po['vendor']?.vendor_name : po[key],
				value: key === 'vendor_name' ? po['vendor']?.vendor_name : po[key],
			}));
		} else {
			selectInputData = [
				{ key: 'is_issued', value: 'Issued' },
				{ key: 'is_pending_approval', value: 'Pending Approval' },
				{ key: 'is_closed', value: 'Closed' },
				{ key: 'is_received', value: 'Received' },
				{ key: 'partially_received', value: 'Partially Received' },
				{ key: 'is_in_transit', value: 'In Transit' },
				{ key: 'is_cancelled', value: 'Cancelled' },
				{ key: 'is_billed', value: 'Billed' },
				{ key: 'is_partially_billed', value: 'Partially Billed' },
			];
		}
		dispatch(setSelectedInputData({ key, data: selectInputData }));
	}

	async function searchSelectedInputItems(key, value) {
		try {
			let optionsList;
			if (key === 'status') {
				optionsList = [
					{ key: 'is_issued', value: 'Issued' },
					{ key: 'is_pending_approval', value: 'Pending Approval' },
					{ key: 'is_closed', value: 'Closed' },
					{ key: 'is_received', value: 'Received' },
					{ key: 'partially_received', value: 'Partially Received' },
					{ key: 'is_in_transit', value: 'In Transit' },
					{ key: 'is_cancelled', value: 'Cancelled' },
					{ key: 'is_billed', value: 'Billed' },
					{ key: 'is_partially_billed', value: 'Partially Billed' },
				];
			} else {
				const { purchaseOrders } = await fetchPurchaseOrders({
					pageSize: 1000,
					filterBy: key,
					filterValue: value,
				});
				optionsList = purchaseOrders?.map((po) => ({
					key: key === 'vendor_name' ? po['vendor']?.vendor_name : po[key],
					value: key === 'vendor_name' ? po['vendor']?.vendor_name : po[key],
				}));
			}

			dispatch(setSelectedInputData({ key, data: optionsList }));
		} catch (error) {
			toast.error(error?.message || 'Something went wrong!');
		}
	}

	async function handleApplyFilters(params) {
		try {
			if (Object.keys(params).length === 0) return;

			if (params.status) {
				setHeaderDropDown(params.status);
			}

			const { purchaseOrders, totalPages } = await getPurchaseOrders({
				orderBy: advanceFilterOrderby,
				sortBy: advanceFilterSortBy,
				page: advanceFilterPage,
				pageSize: advanceFilterPageSize,
				filters: params,
			});

			dispatch(setAdvanceFilterTotalPage({ totalPages: totalPages }));
			setTableData(mappedTableData(purchaseOrders));
			setIsAdvanceFilterOpen(false);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong! Try again.');
		}
	}

	useEffect(() => {
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			handleFetchPurcahseOrders();
		}
	}, [purchaseOrderParams, advanceFilterPage, isAdvanceFilterApplied]);

	useEffect(() => {
		handleIsBulkUpdateDisableButton();
	}, [bulkAction]);

	return (
		<div style={{ overflow: 'auto' }}>
			{bulkAction && bulkAction.length > 0 ? (
				<div
					className="product-pg-header"
					style={{ padding: '1.6rem 1rem' }}
				>
					<div className="dropdown text-end">
						<p className="d-block link-dark text-decoration-none">Bulk Actions</p>
					</div>
					<div className="add-product-button">
						<Button
							type="button"
							disabled={
								!hasPermission('purchases.purchase_orders.delete', user?.role?.role_permissions)
							}
							button="Delete"
							className="mt-0 px-4 btn-gray"
							onClick={handleOpenBulkDeletePurchaseOrderModal}
						/>

						<div className="dropdown">
							<button
								className="btn btn-gray mt-0 px-4 dropdown-toggle"
								style={{
									width: '86px',
									height: '32px',
									fontSize: '14px',
									fontWeight: '500',
								}}
								type="button"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								Share
							</button>
							<ul
								className="dropdown-menu font-14"
								style={{ minWidth: '86px' }}
							>
								<li>
									<button
										className="dropdown-item"
										disabled={
											!hasPermission(
												'purchases.purchase_orders.download_print_pdf',
												user?.role?.role_permissions,
											)
										}
										onClick={() => handlePrintAndDownloadPdf('print')}
									>
										Print
									</button>
								</li>
								<li>
									<button
										className="dropdown-item"
										disabled={
											!hasPermission(
												'purchases.purchase_orders.download_print_pdf',
												user?.role?.role_permissions,
											)
										}
										onClick={() => handlePrintAndDownloadPdf('download')}
									>
										Download Pdf
									</button>
								</li>
								<li>
									<button
										className="dropdown-item"
										disabled={
											!hasPermission(
												'purchases.purchase_orders.export',
												user?.role?.role_permissions,
											)
										}
										onClick={handleDownloadTableData}
									>
										Download Excel
									</button>
								</li>
							</ul>
						</div>

						<div className="dropdown">
							<button
								disabled={isBulkActionButtonDisabled}
								className="btn btn-gray mt-0 px-4 dropdown-toggle"
								style={{
									width: '136px',
									height: '32px',
									fontSize: '14px',
									fontWeight: '500',
								}}
								type="button"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								Bulk Update
							</button>
							<ul
								className="dropdown-menu font-14"
								style={{ minWidth: '136px' }}
							>
								{showIssuedButton && (
									<li>
										<a
											className="dropdown-item"
											href="#"
											onClick={() => handleUpdateBulkPurchaseOrder('is_issued')}
										>
											Mark As Issued
										</a>
									</li>
								)}
								{showCancelOrderButton && (
									<li>
										<a
											className="dropdown-item"
											href="#"
											onClick={() => handleUpdateBulkPurchaseOrder('is_cancelled')}
										>
											Cancel Order
										</a>
									</li>
								)}
							</ul>
						</div>
						<Button
							type="button"
							button="Convert To Bill"
							disabled={true}
							className="mt-0 px-4 btn-gray"
						/>
						<Button
							type="button"
							button=""
							className="mt-0 px-4 btn-danger"
							close
							onClick={() => {
								setBulkAction(false);
								setBulkAction([]);
								deselectRows && deselectRows();
							}}
						/>
					</div>
				</div>
			) : (
				<div className="product-pg-header add-product">
					<div
						className="dropdown text-end d-flex"
						style={{ gap: '12px', alignItems: 'center', display: 'flex' }}
					>
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: {},
											},
											'',
											'Active Purchase Orders',
										)
									}
								>
									Active Purchase Orders
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: { is_draft: 1 },
											},
											'active',
											'Draft',
										)
									}
								>
									Draft
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: { is_pending_approval: 1 },
											},
											'is_pending_approval',
											'Pending Approval',
										)
									}
								>
									Pending Approval
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: { is_approved: 1 },
											},
											'is_approved',
											'Approved',
										)
									}
								>
									Approved
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: { is_issued: 1 },
											},
											'is_issued',
											'Issued',
										)
									}
								>
									Issued
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: { is_billed: 1 },
											},
											'is_billed',
											'Billed',
										)
									}
								>
									Billed
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: { is_closed: 1 },
											},
											'is_closed',
											'Closed',
										)
									}
								>
									Closed
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: { is_cancelled: 1 },
											},
											'is_cancelled',
											'Cancelled',
										)
									}
								>
									Cancelled
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: { is_received: 1 },
											},
											'is_received',
											'Received',
										)
									}
								>
									Received
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: { is_partially_received: 1 },
											},
											'is_partially_received',
											'Partially Received',
										)
									}
								>
									Partially Received
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: { is_partially_billed: 1 },
											},
											'is_partially_billed',
											'Partially Billed',
										)
									}
								>
									Partially Billed
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: { is_in_transit: 1 },
											},
											'is_in_transit',
											'In Transit',
										)
									}
								>
									In Transit
								</a>
							</li>
						</ul>
						<div>
							{isAdvanceFilterApplied ? (
								<div>
									<button
										onClick={() => {
											dispatch(clearAdvanceFilter());
											setHeaderDropDown('Active Purchase Orders');
										}}
										style={{
											background: 'transparent',
											color: '#FF0000',
											fontSize: '14px',
											cursor: 'pointer',
											fontWeight: '600',
											lineHeight: '24px',
										}}
									>
										<img
											src={clearAllFilter}
											alt=""
											style={{ width: '18px', height: '18px', marginRight: '8px' }}
										/>
										Clear All Filters
									</button>
								</div>
							) : (
								<button
									onClick={() => setIsAdvanceFilterOpen(true)}
									style={{
										color: '#2E63F6',
										background: 'transparent',
										fontSize: '14px',
										cursor: 'pointer',
										fontWeight: '600',
										lineHeight: '24px',
									}}
								>
									<img
										src={advanceFilterIcon}
										alt=""
										style={{ width: '18px', height: '18px', marginRight: '8px' }}
									/>
									Advanced Filters
								</button>
							)}
						</div>
					</div>

					<div className="add-product-button column-gap-0">
						<Button
							type="button"
							className="btn-primary mt-0 px-3"
							disabled={
								!hasPermission('purchases.purchase_orders.create', user?.role?.role_permissions)
							}
							button="Create New Purchase Order"
							add
							onClick={() => navigateRouter(`/user/${suburl}/purchases-order-create`)}
						/>
						<div className="dropdown text-end ms-3">
							<a
								href="#"
								className="d-block link-dark text-decoration-none"
								id="dropdownUser1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<img src={sortbydot} />
							</a>
							<ul
								className="dropdown-menu font-14"
								aria-labelledby="dropdownUser1"
								style={{ minWidth: '240px' }}
							>
								<li>
									<a
										className="dropdown-item sortBy"
										style={{ cursor: 'not-allowed' }}
									>
										Sort By
									</a>
								</li>

								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'purchase_order_id', sortBy: 'asc' })}
									>
										Purchase Order Id
										<span>{sortIconMap[sortDirection?.purchase_order_id]}</span>
									</a>
								</li>

								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'date', sortBy: 'asc' })}
									>
										Date
										<span>{sortIconMap[sortDirection?.date]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'created_at', sortBy: 'asc' })}
									>
										Created Time
										<span>{sortIconMap[sortDirection?.created_at]}</span>
									</a>
								</li>

								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'vendor_name', sortBy: 'asc' })}
									>
										Vendor Name
										<span>{sortIconMap[sortDirection?.vendor_name]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() =>
											sortDataList({ orderBy: 'expected_delivery_date', sortBy: 'asc' })
										}
									>
										Expected Delivery Date
										<span>{sortIconMap[sortDirection?.expected_delivery_date]}</span>
									</a>
								</li>

								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'updated_at', sortBy: 'asc' })}
									>
										Last Modified time
										<span>{sortIconMap[sortDirection?.updated_at]}</span>
									</a>
								</li>
								<li>
									<a
										className={`dropdown-item ${!hasPermission('purchases.purchase_orders.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
										onClick={() => exportData(`purchase_order`)}
									>
										Export purchase Order
									</a>
								</li>

								<li>
									<a
										className="dropdown-item"
										onClick={() => {
											setHeaderDropDown('Active Purchase Orders');
											setPurchaseOrderParams({
												page: 1,
												pageSize: 20,
												orderBy: 'created_at',
												sortBy: 'desc',
												filters: {},
											});
										}}
									>
										Refresh
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			)}

			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					padding: '0px 10px',
				}}
			>
				{isAdvanceFilterApplied && (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									handleOnFocusSelectedFilterInput(item?.key);
								}}
								onChange={(value) => {}}
								onSelect={(option) => {
									if (item?.key === 'status') {
										setHeaderDropDown(option?.value);
									}
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
									handleApplyFilters(params);
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									if (item.key === 'status') {
										setHeaderDropDown('Active Purchase Orders');
									}
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div style={{ marginBottom: '8px', cursor: 'pointer' }}>
							<img
								src={addFilter}
								alt="Apply Filter"
								onClick={() => setIsAdvanceFilterOpen(true)}
							/>
						</div>
					</div>
				)}
			</div>

			{isDeleteBulkConfirmationModalOpen && (
				<DeletePurchaseOrderModel
					isDeleteBulkConfirmationModalOpen={isDeleteBulkConfirmationModalOpen}
					setIsDeleteBulkConfirmationModalOpen={() => {
						setBulkAction(false);
						setBulkAction([]);
						setSelectedPRListForDelete([]);
						deselectRows && deselectRows();
						setIsDeleteBulkConfirmationModalOpen(false);
					}}
					selectedPurchaseOrderNumberListFoPR={selectedPRListForDelete}
					handleBulkDelete={() => handleUpdateBulkPurchaseOrder('is_deleted')}
					purchaseOrderLength={bulkAction.length}
				/>
			)}

			{loader ? (
				<PageLoader />
			) : (
				<div className="productTable-body">
					<Table
						row={tableData}
						coloum={PurchaseOrderColoum}
						className="productTable"
						onRowClick={onRowClick}
						bulkAction={bulkAction}
						action={setBulkAction}
						style={isAdvanceFilterApplied ? { height: 'calc(100vh - 185px)' } : {}}
						onDeselectAll={handleDeselectAll}
					/>
				</div>
			)}
			<Pagination
				currentPage={isAdvanceFilterApplied ? advanceFilterPage : purchaseOrderParams.page}
				totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : totalPages}
				onChangePage={handlePageChange}
			/>

			{/* Advance Filter  */}
			{isAdvanceFilterOpen && (
				<AdvanceFilter
					modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
					isOpen={isAdvanceFilterOpen}
					advanceFilterOptions={advanceFilterOptions?.purchase_order}
					onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
					onClose={() => {
						setIsAdvanceFilterOpen(false);
					}}
					onApply={handleApplyFilters}
				/>
			)}
		</div>
	);
};

export default PurchaseOrder;
